export default {
    addEmail: {
        button: '追加',
        description:
            '新しいメールアドレスを追加すると認証メールが自動的に送信されます。',
        helper: '例：name@example.com',
        label: 'メールアドレスを追加',
        title: 'メールアドレスの追加',
    },
    emailAddresses: {
        delete: '削除',
        description:
            '本アドレスはユーザー関連の通知やパスワード再設定の連絡などに使われます。 また、メールアドレスは各種通知の送り先に指定できます。',
        email: 'メールアドレス',
        newDescription:
            '「本メールアドレス」は、ログインに利用できるアドレスで、ユーザー関連の通知とパスワード再設定の連絡の送り先となります。',
        primary: ' 本メールアドレス',
        sendConfirmationLink: '認証メールを送信',
        setAsPrimary: '本メールアドレスに設定',
        status: 'ステータス',
        title: 'メールアドレス',
        unverified: '未認証',
        verified: '認証済み',
    },
    formTitle: 'メールアドレス設定',
    modal: {
        description:
            'メールアドレス {{email}} を削除しますが、よろしいでしょうか。',
        title: 'メールアドレスを削除',
    },
    notificationAddresses: {
        cancel: 'キャンセル',
        company: '会社',
        description:
            '各会社アカウント関連の通知の送り先はこちらで設定できます。設定できる送り先は、上記に追加済みのメールアドレスのみです。  受信する通知の種類の設定は<0>通知設定</0>で行います。',
        edit: '編集',
        email: 'メールアドレス',
        save: '保存',
        saveSuccess: 'メールアドレスが更新されました。',
        title: 'アカウント関連通知の送り先',
    },
    title: 'メールの設定 - MakeLeaps',
};
